import Discussion from 'shared/components/discussion';
import PinMessage from 'shared/components/pin_message';
import { buildChannel } from 'shared/utilities/channel_builder';
import Page from 'shared/components/page';
import ConcurrentUsers from 'shared/components/concurrent_users';
import Env from 'shared/env';
import SocketAPI from 'vidio-chat';

export default class WebSocketConnection {
  constructor() {
    this.wsConfig = {
      host: Env.vidioChatHost(),
      secure: Env.vidioChatSecure()
    };

    this.discussion = new Discussion();
    this.concurrentUsers = new ConcurrentUsers();
    this.pinMessage = new PinMessage();

    this.ui = {
      websocketContainerDesktop: '.live-container',
      websocketContainerMobile: '.b-livestreaming-section',
      websocketContainerEmbed: '.embed-live-container'
    };

    this.websocketEnabledOnDesktop = $(this.ui.websocketContainerDesktop).attr('data-websocket-enabled')
    this.websocketEnabledOnMobile = $(this.ui.websocketContainerMobile).attr('data-websocket-enabled')
    this.websocketEnabledOnEmbed = $(this.ui.websocketContainerEmbed).data('websocket-enabled')
  }

  init() {
    if(this.websocketEnabledOnDesktop == "true" || this.websocketEnabledOnMobile == "true" || this.websocketEnabledOnEmbed) {
      SocketAPI.createSession(this.wsConfig, {
        onOpenCallback: this.onOpen.bind(this),
        onMessageCallback: this.onMessage.bind(this),
        onConnectFailed: () => {}
      })
    }
  }

  onOpen() {
    SocketAPI.subscribe(buildChannel('utility', 'anti-piracy', Page.id()))
    SocketAPI.subscribe(buildChannel('ccu', 'livestreaming', Page.id()))
  }

  onMessage(message) {
    if (message === null) {
      return;
    }

    if (message.data) {
      try {
        const messageData = JSON.parse(message.data);

        switch(message.type) {
          case 'action':
            return;
          case 'utility/antipiracy':
            window.player.toggleWatermark(messageData.duration);
            break;
          case 'ccu/livestreaming':
            this.concurrentUsers.setConcurrentUserCount(messageData);
            break;
          case 'chat/pin':
            this.pinMessage.renderPinnedMessage(messageData);
            break;
          case 'chat/unpin':
            this.pinMessage.hidePinnedMessageDisplay();
            break;
          case 'chat/message':
            this.discussion.renderChatMessage(messageData);
            break;
        }
      } catch (e) {
        console.error('Error when processing data:', e);
      }
    }
  }
}
